export enum ApiErrorType {}

export interface ApiResponse<T> {
    status?: number;
    body: T;
    error?: string;
    errorType?: ApiErrorType;
}

export type ApiListResponse<T> = ApiResponse<T[]>;

export type ApiPageableResponse<T> = InternalApiPageableResponse<T>;

interface Page {
    number?: number;
    totalElements?: number;
    totalPages?: number;
    first?: boolean;
    last?: boolean;
    size?: number;
}

export interface InternalApiPageableResponse<T> {
    content: T[];
    page: Page;
}
